import {
  PLANTING,
  IN_SEASON,
  HARVEST,
  BASE_LAYERS,
} from '../constants/mapLayerIds';
import { LOCALE_GROUPS } from '../constants/units';

/*
 * TCC unit-qty (unit conversion library) configs
 */
const equipmentSpeed = {
  key: 'kilometer/hour',
  localeGroup: LOCALE_GROUPS.EQUIPMENT_SPEED,
};
const elevation = {
  key: 'meter',
  localeGroup: LOCALE_GROUPS.ELEVATION,
  unitType: 'unitPlural',
};

const layerUnits = {
  [`${IN_SEASON.APPLICATIONS}${LOCALE_GROUPS.APPLICATION_DRY}`]: {
    key: 'kilogram/hectare',
    localeGroup: LOCALE_GROUPS.APPLICATION_DRY,
  },
  [`${IN_SEASON.APPLICATIONS}${LOCALE_GROUPS.APPLICATION_LIQUID}`]: {
    key: 'liter/hectare',
    localeGroup: LOCALE_GROUPS.APPLICATION_LIQUID,
  },
  [PLANTING.POPULATION]: {
    key: 'seed/hectare',
    localeGroup: LOCALE_GROUPS.POPULATION_SHORT,
  },
  [`${PLANTING.POPULATION}${LOCALE_GROUPS.POPULATION_WEIGHT}`]: {
    key: 'kilogram/hectare',
    localeGroup: LOCALE_GROUPS.POPULATION_WEIGHT,
  },
  [PLANTING.TARGET_POPULATION]: {
    key: 'seed/hectare',
    localeGroup: LOCALE_GROUPS.POPULATION_SHORT,
  },
  [`${PLANTING.TARGET_POPULATION}${LOCALE_GROUPS.POPULATION_WEIGHT}`]: {
    key: 'kilogram/hectare',
    localeGroup: LOCALE_GROUPS.POPULATION_WEIGHT,
  },
  [PLANTING.DATE]: {
    processSpecial: 'date',
  },
  [HARVEST.YIELD]: {
    key: 'tonne/hectare',
    localeGroup: LOCALE_GROUPS.YIELD,
  },
  [HARVEST.DATE]: {
    processSpecial: 'date',
  },
  [HARVEST.MOISTURE]: {
    key: 'percent',
    localeGroup: LOCALE_GROUPS.MOISTURE,
  },
  [PLANTING.PLANTER_SPEED]: equipmentSpeed,
  [PLANTING.ORGANIC_MATTER]: {
    key: 'percent',
  },
  [PLANTING.UNIFORM_FURROW]: {
    key: 'percent',
  },
  [PLANTING.DOWN_FORCE]: {
    key: 'kilogram',
    localeGroup: LOCALE_GROUPS.WEIGHT,
  },
  [PLANTING.APPLIED_DOWN_FORCE]: {
    key: 'kilogram',
    localeGroup: LOCALE_GROUPS.WEIGHT,
  },
  [PLANTING.FURROW_MOISTURE]: {
    key: 'percent',
    localeGroup: LOCALE_GROUPS.MOISTURE,
  },
  [PLANTING.CLEAN_FURROW]: {
    key: 'percent',
  },
  [PLANTING.SOIL_TEMPERATURE]: {
    key: 'celsius',
  },
  [PLANTING.TARGET_POPULATION]: {
    key: 'seed/hectare',
    localeGroup: LOCALE_GROUPS.POPULATION_SHORT,
  },
  [HARVEST.COMBINE_SPEED]: equipmentSpeed,
  [BASE_LAYERS.PLANTER_ELEVATION]: elevation,
  [BASE_LAYERS.COMBINE_ELEVATION]: elevation,
};

/**
 * Returns the units key and locale group for the given map layer and crop
 * @param {String} mapLayer
 * @param {String} [localeGroup='']
 * @param {String} crop
 * @return {Object} - Units key and localGroup
 */
export function getLayerUnits(mapLayer, localeGroup = '') {
  return layerUnits[`${mapLayer}${localeGroup}`];
}
